import { render, staticRenderFns } from "./TagChooser.vue?vue&type=template&id=0c2ee69a&"
import script from "./TagChooser.vue?vue&type=script&lang=ts&"
export * from "./TagChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports